const $inject = [];
const lbaFeatureSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaFeatureSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaFeatureSelect.html')
  }
};

lbaFeatureSelect.$inject = $inject;

export default lbaFeatureSelect;



// WEBPACK FOOTER //
// ./src/components/lbaFeatureSelect/lbaFeatureSelectDir.js